import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PricingService} from './service/pricing.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {WebConfigurationModule} from './web-configuration-module/web-configuration.module';
import {NgxMaskModule} from 'ngx-mask';
import {PricingComponent} from './component/pricing/pricing.component';
import {SearchComponent} from './component/search/search.component';
import {ResultComponent} from './component/result/result.component';
import { DltSpinnerComponent } from './component/dlt-spinner/dlt-spinner.component';
import {HtmlInterpolationDirective} from './directive/html-interpolation.directive';
import { MiniPricerDlgComponent } from './component/mini-pricer-dlg/mini-pricer-dlg.component';
import {BsModalRef, ModalModule} from 'ngx-bootstrap';
import { MiniPricerIframeComponent } from './component/mini-pricer-iframe/mini-pricer-iframe.component';
import {ThemeChangerService} from './service/theme-change.service';
import { EmailRatesComponent } from './component/email-rates/email-rates.component';
import {TextMaskModule} from 'angular2-text-mask';
import {CustomEmailValidator} from './directive/email-validator.directive';
import { MiniPricerWidgetComponent } from './component/mini-pricer-widget/mini-pricer-widget.component';
import { RoundPipe } from './component/mini-pricer-widget/round.pipe';
import { MiniPricerGraphComponent } from './component/mini-pricer-graph/mini-pricer-graph.component';
import { ChartsModule } from 'ng2-charts';
// import * as PlotlyJS from 'plotly.js/dist/plotly.js';
// import { PlotlyModule } from 'angular-plotly.js';

// PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
    AppComponent,
    PricingComponent,
    SearchComponent,
    ResultComponent,
    DltSpinnerComponent,
    HtmlInterpolationDirective,
    CustomEmailValidator,
    MiniPricerDlgComponent,
    MiniPricerIframeComponent,
    EmailRatesComponent,
    MiniPricerWidgetComponent,
    RoundPipe,
    MiniPricerGraphComponent
  ],
  imports: [
    WebConfigurationModule.forRoot(),
    NgxMaskModule.forRoot(),
    ModalModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    TextMaskModule,
    ChartsModule,
  ],
  entryComponents: [
    MiniPricerDlgComponent
  ],
  providers: [
    PricingService,
    BsModalRef,
    ThemeChangerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
